<div class="header">
  <h1 class="title">{{ 'gameNotFound.title' | translate }}</h1>
</div>
<a class="button" routerLink="/games">
  {{ 'gameNotFound.backToList' | translate }}
</a>
